import debounce from '../util/debounce';

import {RangeSlider} from './range-slider';

const selectors = {
  form: '[data-sidebar-filter-form]',
  inputs: 'input, select, label, textarea',
  priceMin: '[data-field-price-min]',
  priceMax: '[data-field-price-max]',
  priceMinValue: 'data-field-price-min',
  priceMaxValue: 'data-field-price-max',
  rangeMin: '[data-se-min-value]',
  rangeMax: '[data-se-max-value]',
  rangeMinValue: 'data-se-min-value',
  rangeMaxValue: 'data-se-max-value',
};

class FiltersForm {
  constructor(section) {
    this.form = section.container.querySelector(selectors.form);
    this.filtersInputs = [];

    if (this.form) {
      new RangeSlider(this.form);
      this.filtersInputs = this.form.querySelectorAll(selectors.inputs);
      this.priceMin = this.form.querySelector(selectors.priceMin);
      this.priceMax = this.form.querySelector(selectors.priceMax);

      this.init();
    }
  }

  init() {
    if (this.filtersInputs.length) {
      this.filtersInputs.forEach((el) => {
        el.addEventListener(
          'input',
          debounce(() => {
            if (this.form && typeof this.form.submit === 'function') {
              if (this.priceMin && el.hasAttribute(selectors.priceMinValue) && !this.priceMax.value) {
                this.priceMax.value = this.priceMax.placeholder;
              }

              if (this.priceMax && el.hasAttribute(selectors.priceMaxValue) && !this.priceMin.value) {
                this.priceMin.value = this.priceMin.placeholder;
              }

              this.form.submit();
            }
          }, 500)
        );
      });
    }

    this.form.addEventListener('range:filter:update', () => this.updateRange());
  }

  updateRange() {
    if (this.form && typeof this.form.submit === 'function') {
      const rangeMin = this.form.querySelector(selectors.rangeMin);
      const rangeMax = this.form.querySelector(selectors.rangeMax);
      const priceMin = this.form.querySelector(selectors.priceMin);
      const priceMax = this.form.querySelector(selectors.priceMax);
      const checkElements = rangeMin && rangeMax && priceMin && priceMax;

      if (checkElements && rangeMin.hasAttribute(selectors.rangeMinValue) && rangeMax.hasAttribute(selectors.rangeMaxValue)) {
        const priceMinValue = parseInt(priceMin.placeholder);
        const priceMaxValue = parseInt(priceMax.placeholder);
        const rangeMinValue = parseInt(rangeMin.getAttribute(selectors.rangeMinValue));
        const rangeMaxValue = parseInt(rangeMax.getAttribute(selectors.rangeMaxValue));

        if (priceMinValue !== rangeMinValue || priceMaxValue !== rangeMaxValue) {
          priceMin.value = rangeMinValue;
          priceMax.value = rangeMaxValue;

          this.form.submit();
        }
      }
    }
  }
}

const collectionFiltersForm = {
  onLoad() {
    this.filterForm = new FiltersForm(this);
  },
  onUnload: function () {
    if (this.filterForm && typeof this.filterForm.unload === 'function') {
      this.filterForm.unload();
    }
  },
};
export default collectionFiltersForm;
